(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["movement-gallery"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('pointermove', (event) => {
    if (event.pointerType === 'touch' || !(event.target instanceof Element)) return;
    const media = event.target.closest('.movement-gallery__media');
    if (!media) return;
    const images = media.querySelectorAll('.movement-gallery__image');
    if (images.length < 2) return;
    const rect = media.getBoundingClientRect();
    const progress = Math.max(0, Math.min(0.999, (event.clientX - rect.left) / rect.width));
    const activeIndex = Math.floor(progress * images.length);
    images.forEach((image, index) => image.classList.toggle('is-active', index === activeIndex));
  });

  document.addEventListener('pointerout', (event) => {
    if (!(event.target instanceof Element)) return;
    const media = event.target.closest('.movement-gallery__media');
    if (!media || media.contains(event.relatedTarget)) return;
    media.querySelectorAll('.movement-gallery__image.is-active').forEach((image) => image.classList.remove('is-active'));
  });

  } catch(e) { console.error(e); }
})();
})();
